import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cuid from 'cuid';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
import TabPanel from './TabPanel';
import { TitleConfig, TypographyConfig } from '@vds-core/typography';
import { withVDSManager } from '@vds-core/utilities';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import { onContentKeyDownUpHandler, onTabNavKeyDownHandler, getPhantomLinkPos, shiftAndTabPressed, setOuterLinkRef, handleLinkHover, handleLinkLeave } from '../util/AccessibilityHelpers';
import PhantomLink from '../util/PhantomLink';
import Animator from '../util/Animator';
import { resize, watchTabs, observeEntrance } from '../util/StickyTabHelper';
import { TextLinkCaret as CoreTextLinkCaret } from '@vds-core/buttons';
var propTypes = {
  /**
   * Content that will be rendered in the tabs wrapper.
   */
  children: PropTypes.node,

  /**
   * An optional callback that is called when the selectedIndex changes. Passes parameters (event, tabIndex).
   */
  onTabChange: PropTypes.func,

  /**
   * Sets the Position of Tabs Border.
   */
  linePosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * The initial Active Tab's index.
   */
  selectedIndex: PropTypes.number,

  /**
   * Sets the Position of the Active/Hover Border Accent for All Tabs.
   */
  indicatorPosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * @deprecated indicatorFillTab
   */
  accentFill: PropTypes.bool,

  /**
   * @ignore
   */
  indicatorFillTab: PropTypes.bool,

  /**
   * Minimum Width for All Tabs, when orientation is horizontal.
   */
  minWidth: PropTypes.string,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Rendered height of the tab.
   */
  tabHeight: PropTypes.string,

  /**
   * @deprecated onTabChange
   */
  tabChange: PropTypes.func,

  /**
   * @deprecated minWidth
   */
  minTabWidth: PropTypes.string,

  /**
   * @deprecated indicatorPosition
   */
  accentPosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * @deprecated selectedIndex
   */
  activeTabIndex: PropTypes.number,

  /**
   * @deprecated indicatorPosition
   */
  borderPosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  minHeight: PropTypes.bool,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number,

  /**
   * @ignore
   */
  TextLinkCaret: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Tabs will be displayed in inverted colors if inverted prop is passed.
   */
  inverted: PropTypes.bool,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string
};
var defaultProps = {
  tabChange: undefined,
  onTabChange: undefined,
  linePosition: 'bottom',
  selectedIndex: 0,
  indicatorPosition: 'top',
  accentFill: false,
  indicatorFillTab: false,
  minWidth: undefined,
  minTabWidth: undefined,
  className: null,
  typescale: TypographyConfig.getTypescale(),
  titleConfig: TitleConfig,
  colorConfig: colors,
  TextLinkCaret: CoreTextLinkCaret,
  orientation: 'horizontal'
};
var TabsWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TabsWrapper",
  componentId: "sc-1ggw8n4-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n"])), function (_ref) {
  var isDesktop = _ref.isDesktop,
      orientation = _ref.orientation;
  return isDesktop ? orientation === 'horizontal' ? 'column' : 'row' : 'column';
});
var FlexColWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "FlexColWrapper",
  componentId: "sc-1ggw8n4-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 1 auto;\n"])));
var FlexRowWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "FlexRowWrapper",
  componentId: "sc-1ggw8n4-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  flex: 1 1 auto;\n  width: 100%;\n"])), function (_ref2) {
  var orientation = _ref2.orientation,
      isDesktop = _ref2.isDesktop;
  return !isDesktop || orientation === 'horizontal' ? 'column' : 'row';
});
var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-1ggw8n4-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-basis: ", ";\n  width: ", ";\n  height: fit-content;\n\n  &:focus {\n    outline: 1px dashed\n      ", ";\n  }\n"])), function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation === 'horizontal' ? 'auto' : '0px';
}, function (_ref4) {
  var isDesktop = _ref4.isDesktop;
  return isDesktop ? '100%' : 'auto';
}, function (_ref5) {
  var inverted = _ref5.inverted,
      colorConfig = _ref5.colorConfig;
  return !inverted ? colorConfig.black : colorConfig.white;
});
var TabsContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "TabsContainer",
  componentId: "sc-1ggw8n4-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  border-left: ", ";\n"])), function (_ref6) {
  var linePosition = _ref6.linePosition,
      colorConfig = _ref6.colorConfig;
  return linePosition !== 'none' ? "1px solid ".concat(colorConfig.coolGray3) : null;
});
var SideNavigation = /*#__PURE__*/styled.div.withConfig({
  displayName: "SideNavigation",
  componentId: "sc-1ggw8n4-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref7) {
  var isDesktop = _ref7.isDesktop,
      orientation = _ref7.orientation,
      width = _ref7.width;
  return isDesktop && orientation !== 'horizontal' && "\n      min-width: ".concat(width, "; \n      width: ").concat(width, ";\n  ");
});
var LinkWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "LinkWrapper",
  componentId: "sc-1ggw8n4-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n  margin-top: 0;\n  ", ";\n  ", ";\n"])), function (_ref8) {
  var isDesktop = _ref8.isDesktop,
      orientation = _ref8.orientation;
  return isDesktop && orientation === 'vertical' && "\n    margin-bottom: 0;\n    margin-top: 32px;\n  ";
}, function (_ref9) {
  var positionLink = _ref9.positionLink;
  return positionLink && "\n      position: absolute;\n      top: ".concat(positionLink + 32, "px;\n  ");
});
var ChildWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChildWrapper",
  componentId: "sc-1ggw8n4-7"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StickyWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StickyWrapper",
  componentId: "sc-1ggw8n4-8"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref10) {
  var sticky = _ref10.sticky,
      stickToTop = _ref10.stickToTop,
      stickToBottom = _ref10.stickToBottom,
      headerOffset = _ref10.headerOffset,
      navWidth = _ref10.navWidth;
  return sticky && (stickToBottom ? "\n      position: fixed;\n      bottom: 0;\n      max-width: ".concat(navWidth, "px;\n    ") : stickToTop ? " \n      position: relative;\n    " : "\n      position: sticky;\n      top: ".concat(headerOffset || 0, ";\n      padding-top: 16px;\n    "));
});
var ChildrenContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChildrenContentWrapper",
  componentId: "sc-1ggw8n4-9"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([""])));

var buildBorderStyle = function buildBorderStyle(props) {
  var borderPosition = props.borderPosition,
      linePosition = props.linePosition,
      colorConfig = props.colorConfig;
  var styles = '';

  if (linePosition === 'top' || borderPosition === 'top') {
    styles += "\n      border-top: ".concat(calculateRem(1), " solid ").concat(colorConfig.coolGray3, ";\n      border-bottom: ").concat(calculateRem(1), " solid transparent;\n    ");
  } else if (linePosition === 'bottom' || borderPosition === 'bottom') {
    styles += "\n      border-top: ".concat(calculateRem(1), " solid transparent;\n      border-bottom: ").concat(calculateRem(1), " solid ").concat(colorConfig.coolGray3, ";\n    ");
  }

  return styles;
};

var StyledTabList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledTabList",
  componentId: "sc-1ggw8n4-10"
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  ", ";\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  ", ";\n"])), function (_ref11) {
  var isDesktop = _ref11.isDesktop;
  return !isDesktop && "\n    overflow-x: scroll;\n    overflow: visible;\n    overflow-y: hidden;\n  ";
}, function (props) {
  return buildBorderStyle(props);
});
export var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this2;

    _classCallCheck(this, Tabs);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "_tabHasChanged", function (prevProps) {
      var extractActive = function extractActive(child) {
        return child.props.active || child.props.isActive;
      };

      var prevArray = prevProps.children.map(extractActive);

      var propArray = _this2.props.children.map(extractActive);

      return propArray.findIndex(function (value, index) {
        return value !== prevArray[index] && !!value;
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "_isDesktopViewport", function () {
      var _this2$props = _this2.props,
          viewport = _this2$props.viewport,
          orientation = _this2$props.orientation;
      return (/desktop/g.test(viewport) || viewport === 'tablet') && orientation === 'vertical';
    });

    _defineProperty(_assertThisInitialized(_this2), "ignoreFragments", function (childrenArray) {
      return childrenArray.filter(function (child) {
        return typeof child !== 'boolean';
      }).map(function (child) {
        if (child.type === React.Fragment) {
          return child.props.children instanceof Array ? child.props.children[0] : child.props.children;
        } else {
          return child;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "_mapChildrenForTabs", function () {
      var _this2$props2 = _this2.props,
          viewport = _this2$props2.viewport,
          children = _this2$props2.children,
          orientation = _this2$props2.orientation,
          colorConfig = _this2$props2.colorConfig,
          inverted = _this2$props2.inverted;
      var _this2$state = _this2.state,
          uniqueIds = _this2$state.uniqueIds,
          activeTabIndex = _this2$state.activeTabIndex;
      var isDesktop = /desktop/g.test(viewport) || viewport === 'tablet'; // Check for Explicit overrides of Tabs Properties by Child Tab Properties
      // [
      //   'accentFill',
      //   'indicatorFillTab',
      //   'accentPosition',
      //   'indicatorPosition',
      //   'minWidth',
      //   'minTabWidth',
      //   'tabHeight',
      //   'focusState',
      //   'minHeight',
      // ].forEach(prop => {
      //   props[prop] = this.props[prop];
      //   if (typeof child.props[prop] !== 'undefined') {
      //     props[prop] = child.props[prop];
      //   }
      // });

      return children.map(function (child, index) {
        var _child$props = child.props,
            analyticsTrack = _child$props['data-analyticstrack'],
            track = _child$props['data-track'],
            clickStream = _child$props['data-clickstream'],
            _onClick = _child$props.onClick; // Check for Explicit override of uniqueId on this Tab

        if (typeof child.props.uniqueId !== 'undefined') {
          uniqueIds[index] = child.props.uniqueId;
        }

        var uniqueId = uniqueIds[index];
        var numberOfTabs = children.length;
        return /*#__PURE__*/React.cloneElement(child, {
          viewport: viewport,
          key: index + 1,
          orientation: orientation,
          index: index,
          active: index === activeTabIndex,
          onClick: function onClick(evt) {
            _this2.handleTabClick(index, _onClick, evt);
          },
          setRef: function setRef(tab) {
            return _this2.navElements[index] = tab;
          },
          handleVisibilityChange: _this2._handleChildVisibilityChange,
          currentClicked: index === activeTabIndex,
          children: orientation === 'vertical' && children,
          hide: child.props.hide,
          accentFill: _this2.props.accentFill,
          indicatorFillTab: _this2.props.indicatorFillTab,
          accentPosition: _this2.props.accentPosition,
          indicatorPosition: _this2.props.indicatorPosition,
          minWidth: _this2.props.minWidth,
          minTabWidth: _this2.props.minTabWidth,
          tabHeight: _this2.props.tabHeight,
          focusState: _this2.props.focusState || child.props.focusState,
          minHeight: _this2.props.minHeight || child.props.minHeight,
          typescale: _this2.props.typescale,
          titleConfig: _this2.props.titleConfig,
          uniqueId: uniqueId,
          analyticsTrack: analyticsTrack,
          track: track,
          clickStream: clickStream,
          numberOfTabs: numberOfTabs,
          inverted: inverted,
          colorConfig: colorConfig,
          onBlur: function onBlur() {
            return _this2.navElements[activeTabIndex].tabIndex = 0;
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "_checkChildren", function () {
      var children = _this2.props.children;
      return children.map(function (child, index) {
        return child;
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "refProp", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this2), "_cloneAndAddProps", function (children, viewport) {
      if (!children) return null;
      var _this2$props3 = _this2.props,
          inverted = _this2$props3.inverted,
          colorConfig = _this2$props3.colorConfig;

      if (children && children.type && children.type.displayName && children.type.displayName.includes('TileNavigation')) {
        return /*#__PURE__*/React.createElement(ChildrenContentWrapper, null, /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread(_objectSpread({}, children.props[viewport]), children.props), {}, {
          tabsChild: true
        })));
      }

      if (children.length > 1) {
        return children.map(function (child, index) {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
            inverted: inverted,
            color: inverted ? colorConfig.white : colorConfig.black
          }, child.props), {}, {
            key: index
          }));
        });
      } else {
        return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({
          inverted: inverted,
          color: inverted ? colorConfig.white : colorConfig.black
        }, children.props[viewport]), children.props));
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "_determineTabWidth", function (width) {
      if (typeof width === 'number') {
        return calculateRem(width);
      } else if (typeof width === 'string') {
        return width;
      } else {
        return '25%';
      }
    });

    _this2.observer = undefined;
    _this2.tabRef = undefined;
    _this2.resizeIsActive = false;
    _this2.activeIndex = _this2.props.activeTabIndex || _this2.props.selectedIndex; // We need a set of Unique Ids to match the Tabs with the Panels

    _this2.uniqueIds = {};
    _this2.childrenElements = _this2.ignoreFragments(_this2.props.children);
    _this2.linkRef = null;
    _this2.linkWrapper = null;
    _this2.tabWrapperRef = null;
    _this2.stickyWrapper = null;
    _this2.contentWrapperRef = undefined;
    _this2.keyPressed = {};
    _this2.navElements = [];
    _this2.currentTabIndex = _this2.activeIndex; //must be called in the accessibility to handle arrow keys nav

    _this2.outerLinkId = cuid();

    _this2.childrenElements.forEach(function (child, tabIndex) {
      _this2.uniqueIds[tabIndex] = cuid().substr(-6); // Check for explicit setting of isActive on a Tab

      if (child.props.isActive || child.props.active) {
        _this2.activeIndex = tabIndex;
      }
    }); // if (this.childrenElements && React.Children) {
    //   React.Children.map(this.childrenElements, elem => {
    //     let activeState = elem.props.active;
    //     if (activeState) this.overrideActive = true;
    //   });
    // }


    _this2.state = {
      activeTabIndex: _this2.overrideActive ? undefined : _this2.activeIndex,
      tabsChildren: _this2.childrenElements,
      uniqueIds: _this2.uniqueIds,
      stickToBottom: false,
      stickToTop: false,
      windowHeight: window.innerHeight,
      navElements: [],
      outerLink: null,
      // link used above or below tab nav items
      phantomLinkActive: false
    };
    return _this2;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var sticky = this.props.sticky;
      var windowHeight = this.state.windowHeight;

      if (sticky && !this.resizeIsActive) {
        // window.addEventListener('resize', e => resize(e, this));
        this.resizeIsActive = true;
      }

      setTimeout(function () {
        if (_this3.contentWrapperRef && _this3.stickyWrapper && _this3.tabWrapperRef) {
          var tabsDiff = _this3.stickyWrapper.offsetHeight - windowHeight;
          var contentHeight = _this3.contentWrapperRef.offsetHeight;

          if (contentHeight - windowHeight > 0 && sticky && tabsDiff > 0) {
            observeEntrance(_this3.contentWrapperRef, tabsDiff, _this3);
          } else {
            if (_this3.tabObserver) _this3.tabObserver.disconnect();

            if (_this3.stickToTop || _this3.stickToBottom) {
              _this3.setState({
                stickToTop: false,
                stickToBottom: false
              });
            }
          }
        }
      }, 35);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var sticky = this.props.sticky;

      if (sticky && this.resizeIsActive) {
        // window.removeEventListener('resize', e => resize(e, this));
        this.resizeIsActive = false;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this4 = this;

      var _this$props = this.props,
          sticky = _this$props.sticky,
          activeTabIndex = _this$props.activeTabIndex,
          selectedIndex = _this$props.selectedIndex;
      var windowHeight = this.state.windowHeight;

      var tabChanged = this._tabHasChanged(prevProps);

      if (sticky && !this.resizeIsActive) {
        // window.addEventListener('resize', e => resize(e, this));
        this.resizeIsActive = true;
      }

      if (this.state.stickToBottom) window.addEventListener('scroll', function (e) {
        return watchTabs(e, _this4);
      });else window.removeEventListener('scroll', function (e) {
        return watchTabs(e, _this4);
      });

      if (activeTabIndex !== prevProps.activeTabIndex || selectedIndex !== prevProps.selectedIndex) {
        var newIndex = activeTabIndex || selectedIndex;
        this.setState({
          activeTabIndex: newIndex
        });
      }

      if (tabChanged !== -1) this.setState({
        activeTabIndex: tabChanged
      });
      setTimeout(function () {
        if (_this4.contentWrapperRef && _this4.stickyWrapper && _this4.tabWrapperRef) {
          var contentHeight = _this4.contentWrapperRef.offsetHeight;
          var tabsDiff = _this4.stickyWrapper.offsetHeight - windowHeight;

          if (contentHeight - windowHeight > 0 && sticky && tabsDiff > 0) {
            observeEntrance(_this4.contentWrapperRef, tabsDiff, _this4);
          } else {
            if (_this4.tabObserver) _this4.tabObserver.disconnect();

            if (_this4.stickToTop || _this4.stickToBottom) {
              _this4.setState({
                stickToTop: false,
                stickToBottom: false
              });
            }
          }
        }
      }, 35);
      prevState.tabsChildren.forEach(function (child, index) {
        var tabsChildren = _this4.ignoreFragments(_this4.props.children);
        /* Handle for when a tab is removed of children do not exist*/


        if (!tabsChildren || !tabsChildren[index] || !tabsChildren[index].props) {
          return;
        }

        var currentPanelContent = tabsChildren[index].props.children;
        var currentPanelLabel = tabsChildren[index].props.label; // TODO: look into an optimization for tabsChildren being replaced individually

        if (prevProps.children !== _this4.props.children) {
          var updatedChildren = _this4.ignoreFragments(_this4.props.children);

          _this4.setState({
            tabsChildren: updatedChildren
          });
        }

        if (child.props.hide !== tabsChildren[index].props.hide) {
          _this4.setState({
            tabsChildren: tabsChildren
          });
        }

        if (child.props.label !== currentPanelLabel) {
          _this4.setState({
            tabsChildren: tabsChildren
          });
        }

        if (child.props.children !== currentPanelContent) {
          _this4.setState({
            tabsChildren: tabsChildren
          });
        }
      });
    }
  }, {
    key: "getFirstVisibleChild",
    value: // This function finds the First Child (Tab) that is currently visible starting with the fromIndex
    function getFirstVisibleChild() {
      var fromIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var firstVisibleChildIndex = -1;
      this.state.tabsChildren.forEach(function (child, index) {
        if (index >= fromIndex && firstVisibleChildIndex === -1 && !child.props.hide) {
          firstVisibleChildIndex = index;
        }
      });
      return firstVisibleChildIndex;
    } // Set the active tab

  }, {
    key: "handleTabClick",
    value: function handleTabClick(activeTabIndex, childFunction, e) {
      var _this$props2 = this.props,
          onTabChange = _this$props2.onTabChange,
          tabChange = _this$props2.tabChange;
      e.persist(); // Call optional TabChanged event callback

      if (typeof tabChange !== 'undefined' && tabChange) {
        tabChange(e, activeTabIndex);
      }

      this.setState({
        activeTabIndex: activeTabIndex
      }, function () {
        if (typeof onTabChange !== 'undefined' && onTabChange) {
          onTabChange(e, activeTabIndex);
        }

        if (childFunction) {
          childFunction(e, activeTabIndex);
        }
      });
    } // Handle Visibility changes requested by a Child (Tab)

  }, {
    key: "handleChildVisibilityChange",
    value: function handleChildVisibilityChange(childIndex, changeType) {
      var changeData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (changeType === 'isActive') {
        if (changeData === true) {
          this.setState({
            activeTabIndex: childIndex
          });
        }
      }

      if (changeType === 'hide' && changeData && childIndex === this.state.activeTabIndex) {
        var activeTabIndex = 0;

        if (changeData === 1) {
          activeTabIndex = this.getFirstVisibleChild();
        } else if (changeData === 2 && childIndex + 1 < this.state.tabsChildren.length) {
          activeTabIndex = this.getFirstVisibleChild(childIndex);
        }

        this.overrideActive = false;
        this.setState({
          activeTabIndex: activeTabIndex
        });
      }
    } // Add any Props that need to be inherited from the <Tabs/> Component

  }, {
    key: "extendTabChild",
    value: function extendTabChild(child, tabIndex) {
      var _this5 = this;

      var _this$state = this.state,
          activeTabIndex = _this$state.activeTabIndex,
          uniqueIds = _this$state.uniqueIds;
      var props = {};

      var _this = this; // Check for Explicit overrides of Tabs Properties by Child Tab Properties


      ['accentFill', 'indicatorFillTab', 'accentPosition', 'indicatorPosition', 'minWidth', 'minTabWidth', 'tabHeight', 'focusState', 'minHeight'].forEach(function (prop) {
        props[prop] = _this5.props[prop];

        if (typeof child.props[prop] !== 'undefined') {
          props[prop] = child.props[prop];
        }
      }); // Check for Explicit override of uniqueId on this Tab

      if (typeof child.props.uniqueId !== 'undefined') {
        uniqueIds[tabIndex] = child.props.uniqueId;
      }

      var uniqueId = uniqueIds[tabIndex]; // Check if Child Tab is currently the Active Tab, or it had a Property change on isActive

      var calcIsActive = activeTabIndex !== undefined ? tabIndex === activeTabIndex : child.props.active;
      var _this$props3 = this.props,
          analyticsTrack = _this$props3['data-analyticstrack'],
          track = _this$props3['data-track'],
          clickStream = _this$props3['data-clickstream'],
          cta = _this$props3['data-sitecat-cta'],
          position = _this$props3['data-sitecat-position'],
          level = _this$props3['data-sitecat-level'],
          dataTrack = _this$props3['data-sitecat-datatrack'];
      return /*#__PURE__*/React.cloneElement(child, {
        key: tabIndex + 1,
        onClick: this.handleTabClick.bind(_this, tabIndex, child.props.onClick),
        handleVisibilityChange: this.handleChildVisibilityChange.bind(_this, tabIndex),
        isActive: calcIsActive,
        active: calcIsActive,
        hide: child.props.hide,
        accentFill: props.accentFill,
        indicatorFillTab: props.indicatorFillTab,
        accentPosition: props.accentPosition,
        indicatorPosition: props.indicatorPosition,
        minWidth: props.minWidth,
        minTabWidth: props.minTabWidth,
        tabHeight: props.tabHeight,
        focusState: props.focusState || child.props.focusState,
        minHeight: props.minHeight || child.props.minHeight,
        typescale: props.typescale,
        titleConfig: props.titleConfig,
        tabIndex: props.tabIndex,
        uniqueId: uniqueId,
        analyticsTrack: analyticsTrack,
        track: track,
        clickStream: clickStream,
        cta: cta,
        position: position,
        level: level,
        dataTrack: dataTrack,
        inverted: props.inverted,
        colorConfig: props.colorConfig
      });
    }
  }, {
    key: "renderTabs",
    value: // use it to set either ref or innerRef prop
    // Encapsulate <Tabs/> component API as props for <Tab/> children
    function renderTabs() {
      return React.Children.map(this.state.tabsChildren, this.extendTabChild.bind(this));
    }
  }, {
    key: "renderTabContent",
    value: function renderTabContent(child, contentIndex) {
      var _this$state2 = this.state,
          activeTabIndex = _this$state2.activeTabIndex,
          uniqueIds = _this$state2.uniqueIds;
      var uniqueId = uniqueIds[contentIndex];
      var label = child.props.label || uniqueId;
      var isActive = activeTabIndex === contentIndex;
      return /*#__PURE__*/React.createElement(TabPanel, {
        label: label,
        uniqueId: uniqueId,
        isHidden: !isActive
      }, child.props.children);
    } // Render current active tab content

  }, {
    key: "renderActiveTabContent",
    value: function renderActiveTabContent() {
      return React.Children.map(this.state.tabsChildren, this.renderTabContent.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props4 = this.props,
          viewport = _this$props4.viewport,
          ctaLink = _this$props4.ctaLink,
          children = _this$props4.children,
          animated = _this$props4.animated,
          startAnimation = _this$props4.startAnimation,
          linePosition = _this$props4.linePosition,
          orientation = _this$props4.orientation,
          headerOffset = _this$props4.headerOffset,
          sticky = _this$props4.sticky,
          TextLinkCaret = _this$props4.TextLinkCaret,
          id = _this$props4.id,
          width = _this$props4.width,
          inverted = _this$props4.inverted,
          colorConfig = _this$props4.colorConfig;
      var _this$state3 = this.state,
          activeTabIndex = _this$state3.activeTabIndex,
          stickToBottom = _this$state3.stickToBottom,
          stickToTop = _this$state3.stickToTop;
      var isDesktop = /desktop/g.test(viewport) || viewport === 'tablet';
      var TabsComponent = orientation === 'horizontal' || !isDesktop ? StyledTabList : TabsContainer;

      var TextLink = function TextLink(_ref12) {
        var viewport = _ref12.viewport,
            ctaLink = _ref12.ctaLink,
            orientation = _ref12.orientation,
            positionLink = _ref12.positionLink,
            onKeyDown = _ref12.onKeyDown;
        return /*#__PURE__*/React.createElement(LinkWrapper, _extends({
          positionLink: positionLink,
          viewport: viewport,
          isDesktop: isDesktop,
          orientation: orientation
        }, _defineProperty({}, _this6.refProp, function (elem) {
          return _this6.linkWrapper = elem;
        })), /*#__PURE__*/React.createElement(TextLinkCaret, _extends({
          id: _this6.outerLinkId,
          onKeyDown: onKeyDown
        }, _defineProperty({}, _this6.refProp, function (elem) {
          return _this6.outerLink = elem;
        }), ctaLink, {
          inverted: inverted
        })));
      };

      var ConditionalTabWrapper = function ConditionalTabWrapper(_ref15) {
        var ctaLink = _ref15.ctaLink,
            children = _ref15.children,
            viewport = _ref15.viewport,
            orientation = _ref15.orientation;
        var isDesktop = /desktop/g.test(viewport) || viewport === 'tablet';

        if (ctaLink && ctaLink !== {}) {
          return /*#__PURE__*/React.createElement("div", null, (!isDesktop || orientation === 'horizontal') && /*#__PURE__*/React.createElement(TextLink, {
            viewport: viewport,
            isDesktop: isDesktop,
            ctaLink: ctaLink,
            orientation: orientation,
            TextLinkCaret: TextLinkCaret
          }), children, isDesktop && orientation !== 'horizontal' && /*#__PURE__*/React.createElement(TextLink, {
            isDesktop: isDesktop,
            ctaLink: ctaLink,
            orientation: orientation
          }));
        }

        return /*#__PURE__*/React.createElement("div", null, children);
      };

      return /*#__PURE__*/React.createElement(TabsWrapper, _extends({
        isDesktop: isDesktop,
        orientation: orientation,
        id: id
      }, _defineProperty({}, this.refProp, function (elem) {
        return _this6.tabRef = elem;
      })), this._checkChildren() ? /*#__PURE__*/React.createElement(FlexColWrapper, null, /*#__PURE__*/React.createElement(FlexRowWrapper, {
        isDesktop: isDesktop,
        orientation: orientation
      }, /*#__PURE__*/React.createElement(SideNavigation, _extends({}, _defineProperty({}, this.refProp, function (elem) {
        return _this6.tabWrapperRef = elem;
      }), {
        isDesktop: isDesktop,
        onKeyDown: function onKeyDown(e) {
          return onTabNavKeyDownHandler(e, _this6);
        },
        onKeyUp: function onKeyUp(e) {
          return shiftAndTabPressed(e, _this6, null, null, false);
        },
        orientation: orientation,
        width: this._determineTabWidth(width, orientation)
      }), /*#__PURE__*/React.createElement(StickyWrapper, _extends({}, _defineProperty({}, this.refProp, function (elem) {
        return _this6.stickyWrapper = elem;
      }), {
        sticky: orientation === 'vertical' && isDesktop && sticky,
        stickToBottom: stickToBottom,
        stickToTop: stickToTop,
        navWidth: this.tabWrapperRef && this.tabWrapperRef.offsetWidth,
        headerOffset: headerOffset
      }), /*#__PURE__*/React.createElement(ConditionalTabWrapper, {
        viewport: viewport,
        ctaLink: ctaLink,
        orientation: orientation
      }, /*#__PURE__*/React.createElement(TabsComponent, {
        viewport: viewport,
        indicatorPosition: "bottom",
        selectedIndex: activeTabIndex,
        activeTabIndex: activeTabIndex,
        linePosition: linePosition,
        isDesktop: isDesktop,
        role: "tablist",
        inverted: inverted,
        colorConfig: colorConfig
      }, this._mapChildrenForTabs())))), /*#__PURE__*/React.createElement(ContentWrapper, _extends({}, _defineProperty({}, this.refProp, function (elem) {
        return _this6.contentWrapperRef = elem;
      }), {
        isDesktop: isDesktop,
        onKeyDown: function onKeyDown(e) {
          return onContentKeyDownUpHandler(e, _this6);
        },
        onKeyUp: function onKeyUp(e) {
          return onContentKeyDownUpHandler(e, _this6);
        },
        role: "tabpanel",
        inverted: inverted,
        colorConfig: colorConfig,
        orientation: orientation
      }), Array.isArray(children) && children.map(function (child, index) {
        var _child$props2 = child.props,
            children = _child$props2.children,
            viewport = _child$props2.viewport;

        if (children && index === activeTabIndex) {
          return /*#__PURE__*/React.createElement(ChildWrapper, null, /*#__PURE__*/React.createElement(Animator, {
            name: "fadeInUp",
            animated: animated,
            startAnimation: startAnimation
          }, _this6._cloneAndAddProps(children, viewport)));
        }
      }), !sticky && ctaLink && (isDesktop || orientation === 'vertical') && /*#__PURE__*/React.createElement(PhantomLink, {
        ctaLink: ctaLink,
        onMouseEnter: function onMouseEnter() {
          return handleLinkHover(_this6.linkWrapper);
        },
        onMouseLeave: function onMouseLeave() {
          return handleLinkLeave(_this6.linkWrapper);
        },
        isActive: this.state.phantomLinkActive,
        orientation: orientation,
        isDesktop: this._isDesktopViewport(),
        getPosition: function getPosition() {
          return getPhantomLinkPos(_this6.outerLink, _this6.tabWrapperRef);
        },
        TextLinkCaret: TextLinkCaret
      })))) : '');
    }
  }]);

  return Tabs;
}(Component);
Tabs.defaultProps = defaultProps;
Tabs.propTypes = propTypes;
export default withVDSManager(Tabs);